import styled from "styled-components";
import { Parallax, Background } from "react-parallax";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Responsive from "./media-queries";

const ParallaxWrapper = styled(Parallax)`
  background: ${(props) =>
    props.colour === "primary"
      ? props.theme.colours.primary
      : props.colour === "secondary"
      ? props.theme.colours.secondary
      : props.theme.colours.white};
  display: flex;
  justify-content: center;

  .react-parallax-background-children {
    height: 100%;
    opacity: 0.2;
    width: 100%;

    .react-parallax-background {
      height: 100vh;

      .gatsby-image-wrapper {
        height: 100vh;
      }
    }
  }
`;

const Content = styled.div`
  align-items: center;
  color: ${(props) =>
    props.colour === "primary"
      ? props.theme.colours.darkGrey
      : props.theme.colours.white};
  display: flex;
  height: 100%;
  justify-content: center;
  line-height: 2rem;
  max-width: 1200px;
  min-height: ${(props) => (props.height ? props.height : "500px")};
  padding: ${(props) => props.theme.layout.gutter.sm} 10px;
  position: relative;
  z-index: 1;

  blockquote {
    font-size: 3rem;
    text-shadow: 0px 0px 30px ${(props) => props.theme.colours.darkGrey};

    cite {
      font-family: ${(props) => props.theme.typography.body.font};
      font-weight: 700;
    }
  }

  ${Responsive.md} {
    padding: ${(props) => props.theme.layout.gutter.md};
  }

  ${Responsive.lg} {
    padding: ${(props) => props.theme.layout.gutter.lg};
  }
`;

export const FullWidth = (props) => {
  return (
    <ParallaxWrapper colour={props.colour} strength={500}>
      <Content height={props.height}>{props.children}</Content>
      {props.image && (
        <Background className="custom-bg">
          <GatsbyImage alt={props.alt ?? ""} image={getImage(props.image)} />
        </Background>
      )}
    </ParallaxWrapper>
  );
};
